import * as React from 'react';
import { FC } from 'react';

import { Box, TertiaryButton } from '@rbilabs/components-library/build/components';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { DialogMemo } from 'components/dialog';
import { LoadingAnimation } from 'components/lottie-animations/reset-location/reset-location';
import { SanityBlockRenderer } from 'components/sanity-block-renderer';
import { useFeatureGeolocationTermsModal } from 'hooks/use-feature-geolocation-terms-modal';

const StyledDialog = styled(DialogMemo)`
  h2 {
    padding: 0;
    text-align: start;
  }
  max-height: 85%;

  ${Styles.desktop} {
    max-width: 520px;
  }

  overflow: auto;
`;

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  & div:first-child {
    height: fit-content;
  }
`;

export interface LocationTermsModalProps {
  isOpen: boolean;
  dismissModal(): void;
}

export const LocationTermsModal: FC<LocationTermsModalProps> = ({ isOpen, dismissModal }) => {
  const { formatMessage } = useIntl();
  const { featureGeolocationTermsData, featureGeolocationTermsLoading } =
    useFeatureGeolocationTermsModal();

  if (!isOpen) {
    return null;
  }

  if (featureGeolocationTermsLoading) {
    return (
      <LoaderContainer>
        <LoadingAnimation />
      </LoaderContainer>
    );
  }

  return (
    <StyledDialog
      modalAppearanceEventMessage="yolo"
      onDismiss={dismissModal}
      heading={featureGeolocationTermsData?.geolocationTermsModalTitle}
      bodyComponent={
        <SanityBlockRenderer
          content={featureGeolocationTermsData?.geolocationTermsContent?.localeRaw}
        />
      }
      actions={
        <Box width="100%" justify="flex-end">
          <TertiaryButton onClick={dismissModal}>{formatMessage({ id: 'close' })}</TertiaryButton>
        </Box>
      }
    />
  );
};
